import ConsignmentStatusBadge from '@components/ConsignmentStatusChip';
import Flex from '@ds/components/layout/Flex';
import Typography from '@ds/components/typography/Typography';
import React from 'react';

import styles from './ConsignmentEditHeader.module.css';

interface Props {
    consignment: {
        status: string;
        number: string;
        updatedAt?: string;
    };
}

const stringToRelativeTime = (str?: string) => (str && new Date(str)?.relativeTime()) || 'never';

const Mobile: React.FC<Props> = ({ consignment }) => (
    <Flex
        direction="row"
        align="center"
        gap={4}
        data-cy="menu-header"
    >
        <ConsignmentStatusBadge
            status={consignment.status}
            data-cy="menu-header-consignment-status"
        />
        <div className={styles.text}>
            <Typography
                variant="body-1"
                weight="semibold"
                component="span"
                data-cy="menu-header-consignment-number"
            >
                {consignment.number}
            </Typography>
            <Typography
                variant="body-2"
                color="secondary-2"
                component="span"
            >
                Updated {stringToRelativeTime(consignment.updatedAt)}
            </Typography>
        </div>
    </Flex>
);

export default Mobile;
